import React from 'react';
import PropTypes from 'prop-types';
// Material-UI
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
// Icons
import { X, Trash } from 'tabler-icons-react';
// Context
import { useTelegram } from './TelegramContext';

export default function BorrarTelegram({ open, onClose }) {
    const { delTelegram, selectionModel, telegrams } = useTelegram();
    const selected = telegrams.find(t => t.id === selectionModel[0]);

    const handleConfirm = async () => {
        const ok = await delTelegram(selectionModel[0]);
        if (ok) onClose();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <div className="usuarios-modal">
                <div className="usuarios-modal-header">
                    <h2 className="usuarios-modal-title">Borrar Grupo</h2>
                    <IconButton size="small" onClick={onClose}><X size={18} strokeWidth={2} /></IconButton>
                </div>
                <div className="usuarios-modal-body usuarios-modal-body--confirm tg-modal-body--confirm">
                    <div className="tg-confirm-icon-wrap">
                        <Trash size={36} strokeWidth={1.5} className="tg-confirm-icon" />
                    </div>
                    <p className="usuarios-confirm-text">
                        ¿Estás seguro de que deseas borrar el grupo <strong>{selected?.nombreGrupo ?? ''}</strong>?
                    </p>
                </div>
                <div className="usuarios-modal-footer">
                    <Button variant="outlined" className="usuarios-modal-cancel" onClick={onClose}>Cancelar</Button>
                    <Button variant="contained" color="secondary" className="usuarios-modal-submit" onClick={handleConfirm}>
                        Borrar
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

BorrarTelegram.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};
